import React from 'react';

const GarageIcon = ({ type, ...rest }) => {
  if (type === 2) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
        <path d="M2.5 20.5001V7.33658L12 3.53857L21.5 7.33658V20.5001H16V12.5001H8V20.5001H2.5ZM9.27875 20.5001V18.7308H11.048V20.5001H9.27875ZM11.1155 17.5001V15.7308H12.8845V17.5001H11.1155ZM12.952 20.5001V18.7308H14.7212V20.5001H12.952Z" fill="#FA1861" />
      </svg>
    )
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <path d="M4 19.0001H6.5V11.0001H17.5V19.0001H20V8.35007L12 5.15007L4 8.35007V19.0001ZM2.5 20.5001V7.33658L12 3.53857L21.5 7.33658V20.5001H16V12.5001H8V20.5001H2.5ZM9.27875 20.5001V18.7308H11.048V20.5001H9.27875ZM11.1155 17.5001V15.7308H12.8845V17.5001H11.1155ZM12.952 20.5001V18.7308H14.7212V20.5001H12.952Z" fill="#212121" />
    </svg>
  );
};

export default GarageIcon;